module.exports = __webpack_public_path__ + "static/media/ballot-check.36eeaef1.svg";